import { PlotList } from './plot-list';
export function createSeriesPlotList() {
    return new PlotList();
}
